import { environment } from "src/environments/environment";

/**
 * @see https://reciteme.com - Accessibility Software including Translator.
 * @see https://knowledge.reciteme.com/knowledge/html - Integration guides.
 */
export class ReciteMe {
  private static enabled = false;

  static configured() {
    return environment.reciteMe.enabled;
  }

  static enable() {
    if (this.enabled) {
      return;
    }

    if (!this.configured()) {
      return;
    }

    if (!environment.reciteMe.clientKey) {
      console.warn(`Recite Me tool is poorly configured and cannot be loaded. Check environment.${environment.name}.ts`);
      return;
    }

    this.injectStyles();
    this.injectScript();

    this.enabled = true;
  }

  private static injectStyles() {
      const head = document.head;
      const link = document.createElement("link");

      link.type = "text/css";
      link.rel = "stylesheet";
      link.href = "/assets/reciteme/reciteme_styles.css";

      head.appendChild(link);
  }

  private static injectScript() {
    const script = document.createElement('script');

    script.innerHTML = `
        var serviceUrl = "//api.reciteme.com/asset/js?key=";
        var serviceKey = "${environment.reciteMe.clientKey}";
        var options = {};  // Options can be added as needed
        var autoLoad = false;
        var enableFragment = "#reciteEnable";
        var loaded = [], frag = !1; window.location.hash === enableFragment && (frag = !0); function loadScript(c, b) { var a = document.createElement("script"); a.type = "text/javascript"; a.readyState ? a.onreadystatechange = function () { if ("loaded" == a.readyState || "complete" == a.readyState) a.onreadystatechange = null, void 0 != b && b() } : void 0 != b && (a.onload = function () { b() }); a.src = c; document.getElementsByTagName("head")[0].appendChild(a) } function _rc(c) { c += "="; for (var b = document.cookie.split(";"), a = 0; a < b.length; a++) { for (var d = b[a]; " " == d.charAt(0);)d = d.substring(1, d.length); if (0 == d.indexOf(c)) return d.substring(c.length, d.length) } return null } function loadService(c) { for (var b = serviceUrl + serviceKey, a = 0; a < loaded.length; a++)if (loaded[a] == b) return; loaded.push(b); loadScript(serviceUrl + serviceKey, function () { "function" === typeof _reciteLoaded && _reciteLoaded(); "function" == typeof c && c(); Recite.load(options); Recite.Event.subscribe("Recite:load", function () { Recite.enable() }) }) } "true" == _rc("Recite.Persist") && loadService(); if (autoLoad && "false" != _rc("Recite.Persist") || frag) document.addEventListener ? document.addEventListener("DOMContentLoaded", function (c) { loadService() }) : loadService();

        // Floating Button:
        function _reciteLoaded() {
            if (reciteMeButton && reciteMeButton.parentNode) {
                reciteMeButton.parentNode.removeChild(reciteMeButton);
            }
            console.log('Recite Me tool loaded successfully.');
        }

        var reciteMeButton;
        var buttonSrc = "/assets/reciteme/reciteme_button.png"
        var buttonSrcHover = "/assets/reciteme/reciteme_button_hover.png"

        function _createReciteButton() {
            var buttonParentSelector = 'body';
            var buttonContainer = document.createElement("div");
            var buttonImage = document.createElement("img");
            var buttonAlt = "Recite Me accessibility and Language Support";
            var buttonTitle = "Launch Recite Me";

            buttonContainer.setAttribute('id', 'reciteme-button');
            buttonContainer.setAttribute('alt', buttonAlt);
            buttonContainer.setAttribute('title', buttonTitle);
            buttonImage.setAttribute('alt', buttonAlt);
            buttonImage.setAttribute('title', buttonTitle);
            buttonImage.setAttribute('src', buttonSrc);
            buttonContainer.appendChild(buttonImage);
            buttonContainer.setAttribute('role', 'button');
            var buttonParent = document.querySelector(buttonParentSelector);
            buttonParent.appendChild(buttonContainer);
            buttonContainer.addEventListener("click", function () {
                loadService();
                return false;
            });
            buttonContainer.addEventListener('mouseover', function() {
                buttonImage.setAttribute('src', buttonSrcHover);
            });
            buttonContainer.addEventListener('mouseout', function() {
                buttonImage.setAttribute('src', buttonSrc);
            });
            reciteMeButton = buttonContainer;
        }
        _createReciteButton();
    `;

    document.head.appendChild(script);
  }
}
